import React, { ReactElement, ReactNode } from "react";
import * as ui from "../native";
import { ContextData } from "./BuildContext";
import ThemeWrapper from "../components/ThemeWrapper";
import GlobalFunctions from "../utils/GlobalFunctions";
import Admin from "../models/Admin";
import Business from "../models/Business";
import { StyleThemeData } from "../components/ThemeWrapper";

export type RouterController = (node: ReactNode) => void;

const pageRouters: Map<string, RouterController> = new Map<
  string,
  RouterController
>();

export default class PageNavigator {
  public static defaultOverlay: ui.OverlayController;
  public static themeUpdateListener = () => {};
  public kIsWeb = true;
  public ctx: ContextData;
  public constructor(ctx: ContextData) {
    this.ctx = ctx;
  }
  public static addListener(target: string, listener: RouterController) {
    pageRouters.set(target, listener);
  }
  public static removeListener(target: string) {
    pageRouters.remove(target);
  }
  public static of(ctx: ContextData): PageNavigator {
    return new PageNavigator(ctx);
  }
  public wrapTheme(widget: ReactNode): ReactNode {
    let mediaQuery = ui.MediaQuery.of(this.ctx);

    return ThemeWrapper({ child: widget });
  }
  public push(
    replace: boolean,
    widget: ReactNode,
    title: string,
    path: string,
    target: string
  ): void {
    if (this.kIsWeb) {
      if (replace) {
        window.history.replaceState(null, title, path);
      } else {
        window.history.pushState(null, title, path);
      }
    }

    widget = this.wrapTheme(widget);

    if (!target) {
      target = "";
    }

    let listener = pageRouters.get(target);

    if (listener) {
      listener(widget);
    }
  }
  public pop(): void {
    this.close();
  }
  public close(): boolean {
    if (this.ctx.popup) {
      this.ctx.popup.hidePopup({});

      return true;
    } else {
      return false;
    }
  }
  public pushAdminBusinessDetailsPage(
    d3eParams?: Partial<{
      replace: boolean;
      target: string;
      business: Business;
    }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    let business = d3eParams?.business;

    this.push(
      replace,
      GlobalFunctions.AdminBusinessDetailsPage({ business: business }),
      "",
      "#admin-business-details-page",
      target
    );
  }
  public pushAdminBusinessManagementPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.AdminBusinessManagementPage({}),
      "",
      "#admin-business-management-page",
      target
    );
  }
  public pushAdminCategoryManagementPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.AdminCategoryManagementPage({}),
      "",
      "#admin-category-management-page",
      target
    );
  }
  public pushAdminConfigurationPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.AdminConfigurationPage({}),
      "",
      "#admin-configuration-page",
      target
    );
  }
  public pushAdminDashboardPage2(
    d3eParams?: Partial<{ replace: boolean; target: string; admin: Admin }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    let admin = d3eParams?.admin;

    this.push(
      replace,
      GlobalFunctions.AdminDashboardPage2({ admin: admin }),
      "",
      "#admin-dashboard-page2",
      target
    );
  }
  public pushAdminHomePage(
    d3eParams?: Partial<{ replace: boolean; target: string; admin: Admin }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    let admin = d3eParams?.admin;

    this.push(
      replace,
      GlobalFunctions.AdminHomePage({ admin: admin }),
      "",
      "#admin-home-page",
      target
    );
  }
  public pushAdminLoginPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.AdminLoginPage({}),
      "",
      "#admin-login-page",
      target
    );
  }
  public pushAdminSignupPage(
    d3eParams?: Partial<{ replace: boolean; target: string }>
  ): void {
    let replace = d3eParams?.replace ?? true;

    let target = d3eParams?.target;

    this.push(
      replace,
      GlobalFunctions.AdminSignupPage({}),
      "",
      "#admin-signup-page",
      target
    );
  }
  public applyTheme(d3eParams?: Partial<{ theme: string }>): void {
    let theme = d3eParams?.theme;

    /*
TODO
*/

    switch (theme) {
      case "EdgeTheme": {
        StyleThemeData.current = StyleThemeData.createEdgeTheme();

        PageNavigator.themeUpdateListener();

        /*
TODO ThemeBuilder.of(this.ctx).rebuild();
*/
        break;
      }
      default: {
        StyleThemeData.current = StyleThemeData.createEdgeTheme();

        PageNavigator.themeUpdateListener();

        /*
TODO ThemeBuilder.of(this.ctx).rebuild();
*/
      }
    }
  }
  public getProjectThemeNames(): string[] {
    return ["EdgeTheme"];
  }
  public getCurrentThemeName(): string {
    return StyleThemeData.current.themeName;
  }
}
